import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { withFirebase } from './Firebase';
import * as ROUTES from './routes';

import {
    Alert,
    Button,
    Container ,
    Col,
    Input,
    InputGroup,
    Row,
} from 'reactstrap';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const SignUpPage = () => (
    <Container fluid className="dark-mode app-mode">
        <Row>
            <Col>
                <h1 className="text-center">Sign Up</h1>
                <SignUpForm />
                <p>
                    Have an account? <Link to={ROUTES.SIGN_IN}>Sign In</Link>
                </p>
            </Col>
        </Row>
    </Container>
);

const INITIAL_STATE = {
    username: '',
    email: '',
    passwordOne: '',
    passwordTwo: '',
    error: null,
  };

class SignUpFormBase extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    onSubmit = event => {
        const { username, email, passwordOne } = this.state;

        this.props.firebase
          .doCreateUserWithEmailAndPassword(email, passwordOne)
          .then(authUser => {
            // Create a user in your Firebase realtime database
            return this.props.firebase
              .user(authUser.user.uid)
              .set({
                username,
                email,
              });
          })
          .then(authUser => {
            this.setState({ ...INITIAL_STATE });
            this.props.history.push(ROUTES.HOME);
          })
          .catch(error => {
            this.setState({ error });
          });

        event.preventDefault();
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const {
            username,
            email,
            passwordOne,
            passwordTwo,
            error,
        } = this.state;

        const isInvalid =
            passwordOne !== passwordTwo ||
            passwordOne === '' ||
            email === '' ||
            username === '';

            return (
                <form onSubmit={this.onSubmit}>
                { error ? (
                    <Alert color="danger">
                        <p>{error.message}</p>
                    </Alert>
                ): (
                    <div></div>
                )}
                <InputGroup>
                    <Input
                        name="username"
                        value={username}
                        onChange={this.onChange}
                        type="text"
                        placeholder="Username"
                    />
                </InputGroup>

                <InputGroup>
                    <Input
                        name="email"
                        value={email}
                        onChange={this.onChange}
                        type="text"
                        placeholder="Email Address"
                    />
                </InputGroup>

                <InputGroup>
                    <Input
                        name="passwordOne"
                        value={passwordOne}
                        onChange={this.onChange}
                        type="password"
                        placeholder="Password"
                 />
                </InputGroup>

                <InputGroup>
                    <Input
                        name="passwordTwo"
                        value={passwordTwo}
                        onChange={this.onChange}
                        type="password"
                        placeholder="Confirm Password"
                    />
                </InputGroup>

                <InputGroup>
                    <Button disabled={isInvalid} type="submit" className="form-control">
                        Sign Up
                    </Button>
                </InputGroup>
            </form>
        );
    }
}

const SignUpForm = withRouter(withFirebase(SignUpFormBase));

const SignUpLink = () => (
    <p>
        Don't have an account? <Link to={ROUTES.SIGN_UP}>Sign Up</Link>
    </p>
);

const SignUpButton = () => (
    <Button color="warning">
        Sign Up
    </Button>
);

export default SignUpPage;
export { SignUpForm, SignUpLink, SignUpButton };